module.exports = __webpack_public_path__ + "img/IMG-20191212-WA0027.81cc3ebc.jpg";